import { IconPack } from '@fortawesome/fontawesome-svg-core';
import { withIconComponent } from '@/core/icons';

import {
    faCheck,
    faTimesCircle,
    faTimes,
    faCheckCircle,
    faInfoCircle,
    faExclamation,
    faExclamationTriangle,
    faChevronLeft,
    faChevronRight,
    faCheckSquare,
    faSquare,
    faMinusSquare,
    faCircle,
    faSortUp,
    faChevronUp,
    faChevronDown,
    faBars,
    faCaretDown,
    faDotCircle,
    faEdit,
    faStar,
    faStarHalf,
    faSync,
    faStepBackward,
    faStepForward,
    faArrowsAltV,
    faPaperclip,
    faPlus,
    faMinus,
    faTrashAlt,
    faAngleDown,
    faAngleLeft
} from '@fortawesome/free-solid-svg-icons';

export const DefaultIconPack: IconPack = {
    faCheck,
    faTimesCircle,
    faTimes,
    faCheckCircle,
    faInfoCircle,
    faExclamation,
    faExclamationTriangle,
    faChevronLeft,
    faChevronRight,
    faCheckSquare,
    faSquare,
    faMinusSquare,
    faCircle,
    faSortUp,
    faChevronUp,
    faChevronDown,
    faBars,
    faCaretDown,
    faDotCircle,
    faEdit,
    faStar,
    faStarHalf,
    faSync,
    faStepBackward,
    faStepForward,
    faArrowsAltV,
    faPaperclip,
    faPlus,
    faMinus,
    faTrashAlt,
    faAngleDown,
    faAngleLeft
};

export const DefaultIcons = {
    back: withIconComponent(faAngleLeft),
    complete: withIconComponent(faCheck),
    cancel: withIconComponent(faTimesCircle),
    close: withIconComponent(faTimes),
    delete: withIconComponent(faTrashAlt),
    clear: withIconComponent(faTimesCircle),
    success: withIconComponent(faCheckCircle),
    info: withIconComponent(faInfoCircle),
    warning: withIconComponent(faExclamation),
    error: withIconComponent(faExclamationTriangle),
    prev: withIconComponent(faChevronLeft),
    next: withIconComponent(faChevronRight),
    checkboxOn: withIconComponent(faCheckSquare),
    checkboxOff: withIconComponent(faSquare),
    checkboxIndeterminate: withIconComponent(faMinusSquare),
    delimiter: withIconComponent(faCircle),
    sort: withIconComponent(faChevronUp),
    expand: withIconComponent(faChevronDown),
    menu: withIconComponent(faBars),
    subgroup: withIconComponent(faCaretDown),
    dropdown: withIconComponent(faAngleDown),
    radioOn: withIconComponent(faDotCircle),
    radioOff: withIconComponent(faCircle),
    edit: withIconComponent(faEdit),
    ratingEmpty: withIconComponent(faStar),
    ratingFull: withIconComponent(faStar),
    ratingHalf: withIconComponent(faStarHalf),
    loading: withIconComponent(faSync),
    first: withIconComponent(faStepBackward),
    last: withIconComponent(faStepForward),
    unfold: withIconComponent(faArrowsAltV),
    file: withIconComponent(faPaperclip),
    plus: withIconComponent(faPlus),
    minus: withIconComponent(faMinus)
};
